module.exports = __webpack_public_path__ + "img/kayaking.694c7679.svg";